import api from "../../api";
import {param, typedQuery} from "../typing";

export const savedViews = typedQuery(["savedViews", param("viewKey")], async viewKey => {
  return await api.savedViews.list(viewKey);
});
